import { ISlot, IProvider } from 'constants/types';

import { Header } from 'components/slider/header';
import { CardsMini } from 'components/slider/cards/mini';
import { ProviderCard } from 'components/template/providers/collection-providers';

import styles from './styles.module.css';
import { Routes } from 'constants/routes';

const PROVIDERS_LINE_LIMIT = 8;

export const SlotsLineProvider = ({ data }: { data: ISlot[] }) => {
  return (
    <div className={styles.wrapper__slots_line}>
      <CardsMini data={data} />
    </div>
  );
};

export const ProvidersLine = ({
  data,
  count,
}: {
  data: IProvider[];
  count: string | undefined;
}) => {
  const providers = Array.isArray(data) ? data : [];

  return (
    <section className={styles.container}>
      <Header
        count={count}
        url={Routes.providers}
        name="Another slots providers"
      />

      <div className={styles.providers_row}>
        {providers.slice(0, PROVIDERS_LINE_LIMIT).map((item) => (
          <ProviderCard key={item._id?.toString()} data={item} />
        ))}
      </div>
    </section>
  );
};
